import { Action, createReducer, on } from '@ngrx/store';
import { LoginAction } from './actions';

interface LoginState {
  token: string | null;
  rol: RolState;
  error: string | null;
  refresh: boolean;
}

interface RolState {
  rolId: string | null;
  rolName: string | null;
}

export const loginStateGenerator: () => LoginState = () =>
  JSON.parse('{"token": null, "error": null, "rol": { "rolName": null, "rolId": null }, "refresh": false}');

export const initialState: LoginState = loginStateGenerator();

const featureReducer = createReducer(
  initialState,
  on(LoginAction.setToken, (state, { token }) => ({
    ...state,
    token,
  })),

  on(LoginAction.onError, (state, { error }) => ({
    ...state,
    error,
  })),

  on(LoginAction.resetState, (_) => loginStateGenerator()),

  on(LoginAction.initSesion, (state) => ({
    ...state,
  })),

  on(LoginAction.refreshToken, (state) => ({
    ...state,
    refresh: true,
  })),

  on(LoginAction.setRol, (state, rol: RolState) => ({
    ...state,
    rol: {
      rolName: rol.rolName,
      rolId: rol.rolId,
    },
  }))
);

function Reducer(state: LoginState | undefined, action: Action) {
  return featureReducer(state, action);
}

const getToken = (state: LoginState) => (state ? state.token : '');
const getError = (state: LoginState) => (state ? state.error : '');
const getRefresh = (state: LoginState) => (state ? state.refresh : false);
const getRol = (state: LoginState) => (state ? state.rol : { rolName: null, rolId: null } );

export const LoginReducer = {
  Reducer,
  getToken,
  getError,
  getRefresh,
  getRol
};

export { LoginState, RolState };
